<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">Modifier un contributeur</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom du contributeur
                    <CustomInput :disabled="true" class="stretch" :value="value.name" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Identifiant OSM du contributeur
                    <CustomInput :disabled="true" class="stretch" :value="value.id.toString()" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Ce contributeur est-il interne à votre organisme ?&nbsp;
                    <CustomCheckbox class="stretch" v-model="value.internal"></CustomCheckbox>
                </label>
            </div>
            <div class="form-control">
                <label>
                    Faut-il <b>valider automatiquement</b> toutes les actions de ce contributeur
                    ?&nbsp;
                    <CustomCheckbox
                        class="stretch"
                        v-model="value.auto_validation"
                    ></CustomCheckbox>
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomCheckbox from './../Checkbox';

export default {
    props: ['value'],
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomCheckbox,
    },
};
</script>

<style lang="scss"></style>
